<template>
  <v-app>
    <v-container
      fluid
      tag="section"
      class="pt-0"
    >
      <v-row justify="center">
        <v-col
          cols="12 px-6"
        >
          <v-row>
            <v-col class="py-0">
              <v-img
                contain
                src="logo.png"
                height="4rem"
                width="8rem"
              />
            </v-col>
          </v-row>
          <v-card
            flat
            height="12rem"
            class="d-flex align-center justify-center"
          >
            <v-icon
              size="8rem"
              color="red"
            >
              mdi-alert-circle-outline
            </v-icon>
          </v-card>
          <v-row>
            <v-col
              cols="12"
              class="text-center payment-message pa-1"
            >
              Оплата неуспешна
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn
                width="100%"
                depressed
                @click="onClick"
              >
                Вернуться к заказу
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<style scoped>
.payment-message {
  font-size: 1.5rem;
  font-weight: 400;
}
</style>
<script>
import { isEmpty } from "@/views/loyalty/shared/modules/is_object"
import { isBlank } from "@/views/loyalty/shared/modules/utilities"

export default {
  methods: {
    onClick () {
      const pointId = localStorage.getItem('pointId')
      console.log(pointId)
      if (!pointId && pointId != null) { this.$router.push('/paymentsystem?id=' + pointId) }
    }
  }
}
</script>
